import { ref } from 'vue'
import { defineStore } from 'pinia'
import type SearchParameters from "@/types/SearchParameters";

export const useSearchParametersStore =  defineStore('searchParameters',{

    state: () => ({
        searchParameters: {} as SearchParameters
    }),
    getters: {
        getSearchParameters: (state) => {
            return state.searchParameters;
        }
    },
    actions: {
        setSearchParameters(searchParameters: SearchParameters) {
            this.searchParameters = searchParameters;
        }
    }

})